import styled from "styled-components";

export const CallNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  border-bottom: 1px solid #ccc;
  span {
    cursor: default;
  }
  button {
    display: flex;
    justify-content: center;
    padding: 5px 10px;
    border-radius: 5px;
    align-items: center;
  }
`;
export const CallContainer = styled.div`
  height: 85%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;
export const ProfileContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  div {
    width: 50%;
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    gap: 10px;

    img {
      width: 50%;
      height: 50%;
      border-radius: 50%;
      cursor: default;
    }
    span:nth-child(2) {
      text-transform: capitalize;
      font-weight: 600;
      cursor: default;
    }
    span:nth-child(3) {
      cursor: default;
    }
  }
`;
export const CallOptions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;

  div:nth-child(1) {
    span {
      padding: 10px;
      border-radius: 20px;
      background-color: #ff0000c1;
      cursor: pointer;
      color: #fff;
      display: flex;
      font-size: 20px;
      align-items: center;
    }
  }
  div:nth-child(2) {
    display: flex;
    align-items: center;
    gap: 20px;
    span {
      padding: 10px;
      border-radius: 20px;
      color: #fff;
      background-color: #000000a6;
      display: flex;
      cursor: pointer;
      align-items: center;
      font-size: 18px;
    }
  }
`;
// export const CallNav = styled.div``
// export const CallNav = styled.div``
